import {
  GET_CONTRACTOR_PIT_LOOKUPS,
  GET_LOOKUPS_SUCCEED,
  SET_PIT_PLAN,
  GET_ROM_LOOKUPS
} from 'fixtures/actions'
import {
  CONTRACTOR_PIT,
  PIT_PLAN,
  LOOKUP_TYPES,
  CONFORMITY_TYPE,
  CONFORMITY_DEPTS,
  SUPPORT_REQUEST,
  GET_ROMS
} from 'fixtures/api'
import { getAllList } from 'services/cmsService'

// get contractor pit lookup data
export const getContractorPitLookupData = () => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(CONTRACTOR_PIT)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_CONTRACTOR_PIT_LOOKUPS,
      payload: data
    })
  }
}

// set contractor pit plan data
export const setPitPlanData = (id) => {
  return async dispatch => {
    let lastSyncDate = ''
    let data = {}
    let newData = await getAllList(PIT_PLAN(id, lastSyncDate))
    if (newData) {
      data = newData
    }

    dispatch({
      type: SET_PIT_PLAN,
      payload: data
    })
  }
}

// get task lookup by type
export const getLookupByType = (type) => {
  let param
  switch (type) {
    case CONFORMITY_TYPE:
      param = 'CONFORMITY_REPORT&subType=LOCATION_TYPE'
      break;
    case CONFORMITY_DEPTS:
      param = 'CONFORMITY_REPORT&subType=CONCERNED_DEPARTMENT'
      break;
    case SUPPORT_REQUEST:
      param = `${type}&subType=CONCERNED_DEPARTMENT`
      break;
    default:
      param = type
      break;
  }

  return async dispatch => {
    let data = {}
    let newData = await getAllList(LOOKUP_TYPES(param))
    if (newData) {
      data = newData
    }

    dispatch({
      type: `${type}_LOOKUP`,
      payload: data
    })
  }
}

export const getLookup = (type, subType) => {
  return async (dispatch) => {
    const param = `${type}${subType ? `&subType=${subType}`:''}`
    let data = {}
    let newData = await getAllList(LOOKUP_TYPES(param))
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_LOOKUPS_SUCCEED,
      lookupType: type,
      lookupSubType: subType,
      data,
    })
  }
}

export const getRomLookupData = (companyCode) => {
  const params = companyCode ? `?companyCode=${companyCode}` : ''
  return async dispatch => {
    let data = []
    let newData = await getAllList(`${GET_ROMS}${params}`)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_ROM_LOOKUPS,
      payload: data
    })
  }
}

